module.exports = __webpack_public_path__ + "img/23-3.5b2d8131.png";